import { useEffect, useState } from "react";
import { getRestaurantList } from "../services/restaurant";
import { RestaurantList } from "../models/IRestaurantDetail";
import WorkingHoursManager from "../working-hours-module/components/WorkingHoursManager";

export default function AdminWorkingHoursPage() {
  const [restaurantList, setRestaurantList] = useState<RestaurantList>();
  const [selectedId, setSelectedId] = useState<string>("");

  useEffect(() => {
    getRestaurantList().then((res) => {
      if (res.data) setRestaurantList(res.data);
    });
  }, []);

  return (
    <div style={{ padding: "24px", maxWidth: 960, margin: "0 auto" }}>
      <div style={{ marginBottom: 22 }}>
        <h4 style={{ fontWeight: 800, color: "#111827", marginBottom: 4 }}>
          <i className="bi bi-clock-fill me-2" style={{ color: "#f59e0b" }}></i>Çalışma Saatleri — Admin
        </h4>
        <p style={{ color: "#6b7280", fontSize: "0.88rem", margin: 0 }}>
          Restoran seçin; anlık durumunu görün, gerekirse kapatın, haftalık programını ve özel günlerini yönetin.
        </p>
      </div>

      {/* Restoran seçici */}
      <div style={{ marginBottom: 22, maxWidth: 420 }}>
        <label style={{ fontSize: "0.78rem", fontWeight: 600, color: "#374151", display: "block", marginBottom: 6, textTransform: "uppercase", letterSpacing: "0.05em" }}>
          <i className="bi bi-building me-1"></i>Restoran
        </label>
        <select
          className="form-select form-select-lg"
          style={{ borderRadius: 12, border: "1.5px solid #dee2e6", boxShadow: "0 2px 8px rgba(0,0,0,0.06)", fontWeight: 500 }}
          value={selectedId}
          onChange={(e) => setSelectedId(e.target.value)}
        >
          <option value="" disabled>Restoran seçiniz...</option>
          {restaurantList?.items.map((r) => (
            <option key={r.id} value={r.id}>{r.restourantName}</option>
          ))}
        </select>
      </div>

      {selectedId ? (
        <WorkingHoursManager key={selectedId} restaurantId={selectedId} />
      ) : (
        <div style={{ textAlign: "center", padding: "60px 0", color: "#9ca3af" }}>
          <i className="bi bi-shop" style={{ fontSize: "2.5rem", display: "block", marginBottom: 10 }}></i>
          <span style={{ fontSize: "0.9rem" }}>Çalışma saatlerini görüntülemek için restoran seçin.</span>
        </div>
      )}
    </div>
  );
}
